import { useCallback } from 'react';

export function useGoToSection(sectionId: string, options: { setFocusAfterScroll?: boolean } = {}) {
  const goToSection = useCallback(() => {
    const sectionElement = document.getElementById(sectionId);
    document.getElementById(`${sectionId}`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });

    if (options.setFocusAfterScroll) {
      const sectionRect = sectionElement?.getBoundingClientRect();
      const yPosition = sectionRect ? sectionRect.top + window.pageYOffset : 0;

      window.scrollTo({ top: yPosition, behavior: 'smooth' });
      setTimeout(() => {
        // Make the element programmatically focusable
        if (!sectionElement?.hasAttribute('tabindex')) {
          sectionElement?.setAttribute('tabindex', '-1');
        }
        sectionElement?.focus();
      }, 200);
    }
  }, [sectionId, options]);

  return { goToSection };
}
